import siteSetting from "../config/env/index"
import { getUserType } from "./user"

/**
 * @deprecated Use getStripeOnboardingUrl() instead.
 * Stripe has deprecated Express OAuth for new platforms.
 */
export const getStripeConnectRedirect = () => {
  let redirectUrl
  if (siteSetting.isFarmer) {
    redirectUrl = siteSetting.config.farmerStripeRedirectUrl
  }
  if (siteSetting.isHost) {
    redirectUrl = siteSetting.config.hostStripeRedirectUrl
  }
  const stripeRedirect = `https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=${siteSetting.config.client_id}&scope=read_write&redirect_uri=${redirectUrl}`
  return stripeRedirect
}

/**
 * Get the redirect URL for Stripe Connect onboarding.
 * Uses Account Links API instead of deprecated OAuth flow.
 */
export const getStripeOnboardingParams = () => {
  let redirectUrl
  if (siteSetting.isFarmer) {
    redirectUrl = siteSetting.config.farmerStripeRedirectUrl
  }
  if (siteSetting.isHost) {
    redirectUrl = siteSetting.config.hostStripeRedirectUrl
  }

  return {
    userType: getUserType(),
    refreshUrl: redirectUrl,
    returnUrl: redirectUrl,
  }
}
